import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { Hero } from '@components/hero/models';
import { ButtonComponent } from '@shared/components/button';
import { ImageComponent } from '@shared/components/image';
import { TitleComponent } from '@shared/components/title';

@Component({
  selector: 'app-hero',
  imports: [TitleComponent, ButtonComponent, ImageComponent],
  templateUrl: './hero.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent extends AbstractDynamicComponent<Hero> {}
